import { Course } from './../builders/course_builder';
import { College } from './../builders/college_builder';
import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';

angular
  .module('capability-ng-transfer')
  .factory(
    'loadTransferSelectedCoursesCommand',
    (
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngTransferCoursesDatasource: ITransferCoursesDatasource,
      ngCollegeBuilder: typeof College
    ): ICommand => {
      return defineCommand(
        'loadTransferSelectedCoursesCommand',
        (deferred: ng.IDeferred<IQuery[]>, response: ng.IHttpPromiseCallbackArg<any>): void => {
          ngTransferCoursesDatasource.clear();

          // TODO can we get rid of this?
          _.each(response.data.results.colleges, (college) => {
            _.each(college.courses, (course) => {
              course.college_nk = college.nk;
            });
          });

          const courses: Course[] = _.flatten(_.pluck(response.data.results.colleges, 'courses'));
          ngTransferCoursesDatasource.write(courses);

          deferred.resolve(QueryMediator.runQueries(ngTransferCoursesDatasource));
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_selected_courses_command.ts